import { render, staticRenderFns } from "./template-form.vue?vue&type=template&id=53845082"
import script from "./template-form.vue?vue&type=script&lang=js"
export * from "./template-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports